import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableSignedContractInternalPayment = Loadable({
  loader: function loader() {
    return import('../SignedContractInternalPayment.jsx');
  },
  loading: ComponentLoading
});
export default LoadableSignedContractInternalPayment;